import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from '@/plugins/vue-i18n';;
export class ExportMeterElecLogs {
  constructor() {
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportLogs(logs,startDate,endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('rank'),
        key: 1,
        width: 10,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.order_date'),
        key: 2,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.area_name'),
        key: 3,
        width: 10,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.meter_name'),
        key: 4,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.business_name'),
        key: 5,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.order_number'),
        key: 6,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('detail_list'),
        key: 7,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.number_of_units'),
        key: 8,
        width: 15,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.before_unit_do_list'),
        key: 9,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.after_unit_do_list'),
        key: 10,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.amount'),
        key: 11,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.name_of_person_do_list'),
        key: 12,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        key: 13,
        width: 50,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      }
    ]
    let index = 0;
    for (let log of logs) {
      setRowMeterElecLog(log)
    }
    function setRowMeterElecLog(log) {
      index++;
      worksheet.addRow({
        1: index,
        2: log.createdAt ? new Date(moment(log.createdAt).format("YYYY-MM-DD HH:mm:ss")) : "",
        3: log.areaName,
        4: log.meterName,
        5: log.customerName,
        6: log.documentId,
        7: log.typeText,
        8: log.unit,
        9: log.oldUnit,
        10: log.newUnit,
        11: log.totalValue,
        12: log.createdBy,
        13: log.note,
      })
    }
    if(startDate && endDate){
      return this.saveFile(workbook, `meter-digital-elec-logs-${moment(startDate).format("DD-MM-YYYY")}-to-${moment(endDate).format("DD-MM-YYYY")}`);
    }else{
      return this.saveFile(workbook, `meter-digital-elec-logs-${moment(new Date()).format("DDMMYYYY")}`);
    }
  }
}